import hasPermission from '../../../../helpers/permissions';
import session from '../../../../stores/session';
import { Link } from 'react-router-dom';
import { RestrictedInfoComponent } from '../RestrictedInfoComponent';
import './BAASummaryTable.scss';
import { useEffect } from 'react';

export default function BAASummaryTable({
    summaryData, loadingWorkflow, search, setSearch, spid, handleKeyDown,
    translations, workflow, workflowItems, _cur, getWorkflowLast, getWorkflowNext,
    loadingSpid, setSpid, prefix, disabledByUserType, qualityAssurance, displayModuleIssues,
    wsOutcome, setWsOutcome, setConfirmModal, getWorkflowStatuses, links,
    wSpid, setWSpid, sSpid, setSSpid, getSummaryData, searchResults, searchIsLoading,
    wholesalerNotes, setWholesalerNotes, prevWsNotes, wsNoteIndex, setWsNoteIndex,
    submitNotes, rejectIsDisabled
}) {

    useEffect(() => {
        const elements = document.getElementsByClassName('baa-summary-table-row');
        if (!elements) return;
        for (let i = 0; i < elements.length; i++) {
            if (i % 2 === 1) {
                elements[i].classList.add('striped-row');
            }
        }
    }, []);

    return (
        <div className="baa-summary-table-container scale-text">
            <div className="baa-summary-table">
                <div className="baa-summary-table-header">
                    <div className="baa-summary-table-header-row">
                        <div className="header-label" style={{ gridColumn: '1 / 7' }}>
                            {translations['Header_Summary']}
                        </div>
                        <div className="header-label" style={{ gridColumn: '7 / 11' }}>
                        {
                            displayModuleIssues ?
                                (translations['Module_Issues'] ?? "Module Issues")
                            :
                                (translations['Notes'] ?? "Notes")
                        }
                        </div>
                    </div>
                </div>
                <div className="baa-summary-table-body">
                    <div className="baa-summary-left">
                        <div className="baa-summary-table-row">
                            <div className="baa-summary-table-cell">Assigned To</div>
                            <div
                                className="baa-summary-table-cell"
                                style={{ position: 'relative', justifyContent: 'space-between' }}
                            >
                                {summaryData.Assigned_TO_User}
                                {((summaryData.Assigned_TO && !qualityAssurance &&
                                    parseInt(summaryData.Assigned_TO) !== session.user.id) ||
                                    summaryData.inPcOrMs) && <RestrictedInfoComponent />}
                            </div>
                            <div className="baa-summary-table-cell">
                                {translations['Workflow_Status']}
                            </div>
                            <div className="baa-summary-table-cell">
                                <select
                                    disabled={
                                        !hasPermission(prefix, 'WHOLESALER') ||
                                        (disabledByUserType && !qualityAssurance) ||
                                        !summaryData?.Core_SPID
                                    }
                                    value={wsOutcome ?? summaryData.WS_Outcome ?? 'New'}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (["Complete", "Assured", "Reject", "Quality Check Passed", "Complete & Assured"].includes(val)) {
                                            setConfirmModal(val);
                                        } else {
                                            setWsOutcome(val);
                                        }
                                    }}
                                >
                                    {
                                        getWorkflowStatuses({module: prefix, rejectIsDisabled: rejectIsDisabled, isQualityAssurance: (qualityAssurance || displayModuleIssues)}).map(outcome => {
                                            return (
                                            <option 
                                                value={outcome.value}
                                                disabled={outcome.value === "Reject" && rejectIsDisabled ? true : outcome.disabled}
                                            >
                                                {outcome.label}
                                            </option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="baa-summary-table-row">
                            <div className="baa-summary-table-cell" style={{ gridColumn: '1 / -1' }} />
                        </div>
                        <div className="baa-summary-table-row">
                            <div className="baa-summary-table-cell">
                                {translations['Core_SPID']}
                            </div>
                            <div className="baa-summary-table-cell">
                                <div className="spid-search-container">
                                    <input
                                        type="text"
                                        value={loadingWorkflow ? '' : search || spid}
                                        onChange={e => setSearch(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        className='scale-text'
                                    />
                                    {(loadingWorkflow || loadingSpid) && (
                                        <i className="fa fa-spinner fa-spin" />
                                    )}
                                    {workflow && (
                                        <>
                                            <span
                                                className="fas fa-angle-left colour-primary"
                                                onClick={getWorkflowLast}
                                            />
                                            <span>{_cur + 1}/{workflowItems.length}</span>
                                            <span
                                                className="fas fa-angle-right colour-primary"
                                                onClick={getWorkflowNext}
                                            />
                                        </>
                                    )}
                                    <span
                                        className="fas fa-search colour-primary"
                                        onClick={() => setSpid(search)}
                                    />
                                </div>
                            </div>
                            <div className="baa-summary-table-cell">{translations['Water_SPID']}</div>
                            <div className="baa-summary-table-cell">
                                <div className='spid-search-container'>
                                    <input
                                        type="text"
                                        value={wSpid || summaryData.W_SPID || ''}
                                        onChange={e => setWSpid(e.target.value)}
                                        disabled={displayModuleIssues}
                                        className='scale-text'
                                    />
                                    {!displayModuleIssues && (
                                        <span
                                            className="fas fa-search colour-primary"
                                            onClick={() => getSummaryData(wSpid, 'wSpid')}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="baa-summary-table-cell">{translations['Sewerage_SPID']}</div>
                            <div className="baa-summary-table-cell">
                                <div className='spid-search-container'>
                                    <input
                                        type="text"
                                        value={sSpid || summaryData.S_SPID || ''}
                                        onChange={e => setSSpid(e.target.value)}
                                        disabled={displayModuleIssues}
                                        className='scale-text'
                                    />
                                    {!displayModuleIssues && (
                                        <span
                                            className="fas fa-search colour-primary"
                                            onClick={() => getSummaryData(sSpid, 'sSpid')}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="baa-summary-table-row">
                            <div className="baa-summary-table-cell">{translations['Occupancy_Status']}</div>
                            <div className="baa-summary-table-cell">{summaryData.Occupancy}</div>
                            <div className="baa-summary-table-cell">{translations['Water_Wholesaler']}</div>
                            <div className="baa-summary-table-cell">{summaryData.W_Wholesaler_ID}</div>
                            <div className="baa-summary-table-cell">{translations['Sewerage_Wholesaler']}</div>
                            <div className="baa-summary-table-cell">{summaryData.S_Wholesaler_ID}</div>
                        </div>
                        <div className="baa-summary-table-subheader">
                            {translations['dqa_info'] ?? "DQA Info"}
                        </div>
                        <div className="baa-summary-table-row">
                            <div className="baa-summary-table-cell">{translations['Address_DQA']}</div>
                            <div className="baa-summary-table-cell">{summaryData.DQA_Address}</div>
                            <div className="baa-summary-table-cell">{translations['UPRN_DQA']}</div>
                            <div className="baa-summary-table-cell">{summaryData.DQA_UPRN}</div>
                            <div className="baa-summary-table-cell">{translations['VOA_DQA']}</div>
                            <div className="baa-summary-table-cell">{summaryData.DQA_VOA}</div>
                        </div>
                        <div className="baa-summary-table-row">
                            <div className="baa-summary-table-cell">{translations['Address_Insight']}</div>
                            <div className="baa-summary-table-cell">{summaryData.Address_Verified_Insight}</div>
                            <div className="baa-summary-table-cell">{translations['UPRN_Insight']}</div>
                            <div className="baa-summary-table-cell">{summaryData.UPRN_Verified_Insight}</div>
                            <div className="baa-summary-table-cell">{translations['VOA_Insight']}</div>
                            <div className="baa-summary-table-cell">{summaryData.VOA_Verified_Insight}</div>
                        </div>
                        <div className="baa-summary-table-subheader">
                            {translations['uprn_voa_info'] ?? "UPRN & VOA Info"}
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className="baa-summary-table-cell">{translations['CMOS_VOA_No']}</div>
                            <div className="baa-summary-table-cell">{summaryData['CMOS_VOA']}</div>
                            <div className="baa-summary-table-cell">{translations['Matched_VOA_No']}</div>
                            <div className="baa-summary-table-cell">{summaryData['Matched_VOA']}</div>
                            <div className="baa-summary-table-cell">{translations['VOA_Reason_Code']}</div>
                            <div className="baa-summary-table-cell">{summaryData['CMOS_VOA_Reason_Code']}</div>
                            <div className="baa-summary-table-cell">{translations['Status_VOA_No']}</div>
                            <div className="baa-summary-table-cell">{summaryData['DQA_VOA_BA_Status']}</div>
                        </div>
                        <div className="baa-summary-table-row">
                            <div className="baa-summary-table-cell">{translations['CMOS_UPRN']}</div>
                            <div className="baa-summary-table-cell">{summaryData['CMOS_UPRN']}</div>
                            <div className="baa-summary-table-cell">{translations['Matched_UPRN']}</div>
                            <div className="baa-summary-table-cell">{summaryData['Matched_UPRN']}</div>
                            <div className="baa-summary-table-cell">{translations['UPRN_Reason_Code']}</div>
                            <div className="baa-summary-table-cell">{summaryData['CMOS_UPRN_Reason_Code']}</div>
                            <div className="baa-summary-table-cell">{translations['Status_UPRN']}</div>
                            <div className="baa-summary-table-cell">{summaryData['DQA_UPRN_Status']}</div>
                        </div>
                        <div className="baa-summary-table-row">
                            <div className='baa-summary-table-cell'>{translations['UPRN_GISX']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['CMOS_UPRN_GISX']}</div>
                            <div className='baa-summary-table-cell'>{translations['UPRN_GISY']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['CMOS_UPRN_GISY']}</div>
                            <div className='baa-summary-table-cell'>{translations['Matched_CMOS_UPRN_GISX']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['Matched_UPRN_GISX']}</div>
                            <div className='baa-summary-table-cell'>{translations['Matched_CMOS_UPRN_GISY']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['Matched_UPRN_GISY']}</div>
                        </div>
                        <div className="baa-summary-table-subheader">
                            {translations['address_info'] ?? "Address Info"}
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className="baa-summary-table-cell">{translations['CMOS_Address_Single_Line']}</div>
                            <div className="baa-summary-table-cell" colSpan="7">{summaryData['CMOS_Address_Single_Line']}</div>
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className="baa-summary-table-cell">{translations['CMOS_UPRN_Single_Line']}</div>
                            <div className="baa-summary-table-cell" colSpan="7">{summaryData['CMOS_UPRN_Single_Line']}</div>
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className="baa-summary-table-cell">{translations['Matched_UPRN_Address']}</div>
                            <div className="baa-summary-table-cell" colSpan="7">{summaryData['Matched_UPRN_Single_Line']}</div>
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className="baa-summary-table-cell">{translations['CMOS_VOA_Single_Line']}</div>
                            <div className="baa-summary-table-cell" colSpan="7">{summaryData['CMOS_VOA_Single_Line']}</div>
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className="baa-summary-table-cell">{translations['Matched_VOA_Single_Line']}</div>
                            <div className="baa-summary-table-cell" colSpan="7">{summaryData['Matched_VOA_Single_Line']}</div>
                        </div>
                    </div>
                    <div className="baa-summary-right scale-text" style={{ alignContent: 'start' }}>
                        {displayModuleIssues ? (
                            <div className='baa-summary-table-row issues-table-container'>
                                <table className='table borders squish smaller-text left scale-text'>
                                    <thead style={{ border: '1px solid var(--primary)' }}>
                                        <tr>
                                            <th style={{ borderRadius: '0px', border: '1px, solid, var(--primary)', width: '36%' }}>Module</th>
                                            <th style={{ border: '1px, solid, var(--primary)' }}>Issue Type</th>
                                            <th style={{ border: '1px, solid, var(--primary)' }}>Issue</th>
                                            <th style={{ borderRadius: '0px', border: '1px, solid, var(--primary)' }}>Link</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {searchResults?.map(result => {
                                            const key = Object.keys(result)[0];
                                            const issue = Object.values(result[key]).filter(v => v).join(' & ');
                                            const issueType = Object.keys(result[key]).map(k => k.replaceAll('_', ' ')).join(' & ');
                                            return (
                                                <tr key={key}>
                                                    <td>{key}</td>
                                                    <td>{issueType}</td>
                                                    <td>{issue}</td>
                                                    <td>
                                                        <Link to={{ pathname: links[key], state: { spid } }}>
                                                            To Module
                                                        </Link>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        {
                                            searchIsLoading &&
                                            <tr>
                                                <td colSpan={4}>
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <i className="fa fa-spinner fa-spin"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className='baa-summary-table-row notes-container'>
                                <textarea disabled={qualityAssurance ? false : (!hasPermission(prefix, 'WHOLESALER') || disabledByUserType)} className='scale-text' onChange={(event) => setWholesalerNotes(event.target.value.slice(0, 500))} value={wholesalerNotes ?? ''} rows={8} />
                                <div className='notes-index'>
                                    {wholesalerNotes.length}/500
                                </div>
                                <textarea disabled={true} className='scale-text' value={prevWsNotes[wsNoteIndex - 1]?.Note ?? ''} rows={8} />
                                <div className='author-signature-container'>
                                    <div className='author-signature'>
                                        {prevWsNotes.length > 0 ?
                                            prevWsNotes[wsNoteIndex - 1]?.User_Name + " - " +
                                            new Date(prevWsNotes[wsNoteIndex - 1]?.Date).toLocaleString('en-GB', { timeZone: 'Europe/London', hour12: false }).replace(',', '').replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')
                                            : ''}
                                    </div>
                                    <div className='notes-index'>
                                        {wsNoteIndex ?? 0}/{prevWsNotes.length} <i class="fa-solid fa-chevron-left" style={{ cursor: wsNoteIndex !== 1 && wsNoteIndex !== 0 ? 'pointer' : 'unset' }} onClick={() => setWsNoteIndex(wsNoteIndex !== 1 && wsNoteIndex !== 0 ? wsNoteIndex - 1 : wsNoteIndex)} /> <i class="fa-solid fa-chevron-right" style={{ cursor: wsNoteIndex !== prevWsNotes.length ? 'pointer' : 'unset' }} onClick={() => setWsNoteIndex(wsNoteIndex !== prevWsNotes.length ? wsNoteIndex + 1 : wsNoteIndex)} />
                                    </div>
                                </div>
                                <button
                                    disabled={qualityAssurance ? false : (!hasPermission(prefix, 'WHOLESALER') || wholesalerNotes.length < 0 || disabledByUserType)}
                                    className={`button compact scale-text ${(qualityAssurance || hasPermission(prefix, 'WHOLESALER')) && wholesalerNotes.length > 0 ? 'background-primary colour-white' : ''}`}
                                    onClick={() => submitNotes('Wholesaler')}
                                >Submit Notes</button>
                            </div>
                        )}
                        <div className="baa-summary-table-subheader">
                            {translations['meter_info'] ?? "Meter Info"}
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className='baa-summary-table-cell'>{translations['Meter_Address']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['CMOS_Meter_Address_Single_Line']}</div>
                        </div>
                        <div className="baa-summary-table-row">
                            <div className='baa-summary-table-cell'>{translations['Meter_Serial_Number']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['Meter_ID']}</div>
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className='baa-summary-table-cell'>{translations['LUM']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['LUM']}</div>
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className='baa-summary-table-cell'>{translations['Meter_Date']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['Meter_Read_Date_Curr']}</div>
                            <div className='baa-summary-table-cell'>{translations['Last_Meter_Read_Method']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['Meter_Read_Method_Curr']}</div>
                        </div>
                        <div className='baa-summary-table-row'>
                            <div className='baa-summary-table-cell'>{translations['Meter_GISX']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['CMOS_Meter_GISX']}</div>
                            <div className='baa-summary-table-cell'>{translations['Meter_GISY']}</div>
                            <div className='baa-summary-table-cell'>{summaryData['CMOS_Meter_GISY']}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
